import React, { Fragment, useEffect } from "react";
import CreateBannerForm from "../BannerForm/ShopBannerForm";
import Header from "../../subheader/Header";

const UpdateShopBanner = () => {
  useEffect(() => {
    document.title = "Banner";
  }, []);
  return (
    <Fragment>
      <div className="vendor-page-right banner-page-desktop">
        <Header heading={"Update Banner"} search={false} filters={null} />
        <div className="right-content banner-page-content-container">
          <div className="form">
            <CreateBannerForm readOnly={false} state="update" />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UpdateShopBanner;
